import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { get } from 'lodash';
import turf from '@turf/turf';

import { featurePoint2LatLng, featureGetZoom } from '../../../modules/geojson-utilities';
import LeafletMap from '../../components/LeafletMap';

let addOnlineBaseMap;
let customScale;
let customMapsAttribution;
let customZoom;
let customCollapseButton;
let getMapCenter;
let L;

class MapContainerModalMap extends Component {
  modalMap = null;

  modalMapComponent = React.createRef();

  state = {
    clientModulesReady: false,
    isLeafletMapLoaded: get(this, 'modalMapComponent.current.state.isMapLoaded', false),
    isModalMapLoaded: false
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) this.loadClientModules();
  }

  componentDidUpdate() {
    const { clientModulesReady, isLeafletMapLoaded, isModalMapLoaded } = this.state;
    if (clientModulesReady && isLeafletMapLoaded && !isModalMapLoaded) this.initializeMap();
  }

  initializeMap = async () => {
    const { defaultMapCenter, updateDefaultCenter } = this.props;

    this.modalMap = get(this, 'modalMapComponent.current.leafletMap');
    this.modalMap.setView(
      featurePoint2LatLng(getMapCenter({ location: defaultMapCenter })),
      featureGetZoom(defaultMapCenter)
    );

    addOnlineBaseMap(this.modalMap);
    if (this.modalMap.attributionControl)
      this.modalMap.removeControl(this.modalMap.attributionControl);
    if (this.modalMap.zoomControl) this.modalMap.removeControl(this.modalMap.zoomControl);
    if (this.modalMap.collapseButton) this.modalMap.removeControl(this.modalMap.collapseButton);
    customCollapseButton(this.modalMap);
    customZoom(this.modalMap);
    customMapsAttribution(this.modalMap);
    customScale(this.modalMap);
    const centerMarker = L.geoJSON().addTo(this.modalMap);
    let newDefaultMapCenter = defaultMapCenter;
    centerMarker.addData(defaultMapCenter);

    this.modalMap.on('click', event => {
      const coordinates = [event.latlng.lng, event.latlng.lat];
      newDefaultMapCenter = turf.point(coordinates, { zoom: this.modalMap.getZoom() });
      centerMarker.clearLayers();
      centerMarker.addData(newDefaultMapCenter);
      updateDefaultCenter('defaultMapCenter', newDefaultMapCenter);
    });

    this.modalMap.on('zoomend', () => {
      newDefaultMapCenter.properties.zoom = this.modalMap.getZoom();
      centerMarker.clearLayers();
      centerMarker.addData(newDefaultMapCenter);
      updateDefaultCenter('defaultMapCenter', newDefaultMapCenter);
    });

    this.setState({ isModalMapLoaded: true });
  };

  updateMapState = newState => this.setState({ isLeafletMapLoaded: newState });

  async loadClientModules() {
    if (Meteor.isClient) {
      ({
        addOnlineBaseMap,
        customScale,
        customMapsAttribution,
        customZoom,
        customCollapseButton,
        getMapCenter
      } = await import('../../../modules/leaflet-operations'));
      L = await import('leaflet');
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { deployEnv } = this.props;
    return (
      <LeafletMap
        mapId="modalMap"
        headerType="4"
        ref={this.modalMapComponent}
        updateMapState={this.updateMapState}
        deployEnv={deployEnv}
      />
    );
  }
}

MapContainerModalMap.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  defaultMapCenter: PropTypes.object.isRequired,
  updateDefaultCenter: PropTypes.func.isRequired
};

export default MapContainerModalMap;
